import styled from '@emotion/styled'
import { formatInTimeZone } from 'date-fns-tz'
import React from 'react'

import { ScheduledCommunicationList } from '@/types/ScheduledCommunication'

type Props = {
  scheduledCommunication: ScheduledCommunicationList
}

export const MobileScheduledCommunicationCard = ({ scheduledCommunication }: Props) => {
  const { id, destination, content, scheduledDatetime, status } = scheduledCommunication

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const formattedScheduledDatetime = formatInTimeZone(scheduledDatetime, timezone, 'MMM. dd, yyyy, h:mmaaa')

  return (
    <BoxStyled key={id}>
      <div className="scheduled-communication-information grid grid-cols-3">
        <div className="border-r border-secondary">
          <h6>Destination</h6>
          <p>{destination}</p>
        </div>
        <div className="border-r  pl-2 border-secondary">
          <h6>Status</h6>
          <p>{status}</p>
        </div>
        <div className="pl-2">
          <h6>Scheduled Datetime</h6>
          <p>{formattedScheduledDatetime}</p>
        </div>
      </div>
      <div className="mt-2 scheduled-communication-information grid grid-cols-1">
        <div className="text-p-xs leading-180 overflow-hidden whitespace-nowrap">
          <h6>Content</h6>
          <p>{content}</p>
        </div>
      </div>
    </BoxStyled>
  )
}

const BoxStyled = styled.div`
  padding: 0.75rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 1rem;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);

  .scheduled-communication-information {
    div {
      display: flex;
      flex-direction: column;
    }

    h6 {
      color: #787573;
      font-size: var(--text-p-xs);
    }
    p {
      font-size: var(--text-p-xs);
      line-height: 1.8;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    p:hover {
      overflow: visible;
      white-space: normal;
      height: auto;
    }
  }
`
